import(/* webpackMode: "eager" */ "/vercel/path0/client/src/app/forgot-password/page.tsx");
